import React, { useState } from "react";
import { useNavigate } from "react-router";

// Material UI
import { Paper, Typography, Grid } from '@mui/material';

// Components
import { DataGrid, ViewButton, FabContainer, CreateFab } from '@arredo/reactjs-ui';
import Filters from "./filters";
import InternalVoucherModal from './modal';
import useAuthorize from '../../hooks/user/useAuthorize';

// Hooks
import useInternalVouchers from '../../hooks/internalVouchers/useInternalVouchers';
import useCashRegisters from "../../hooks/cashRegisters/useCashRegisters";

// Models
import { columns, title } from '../../models/InternalVoucherEntity';
import { Permissions } from '../../models/Roles';

// Others
import useStyles from './styles';

const InternalVouchers = () => {
    const { cashRegisters } = useCashRegisters({ isImprest: false });
    const { classes } = useStyles();
    const { internalVouchers, loading, totalPage, filters, search, setParameterSearch, clearFilters } = useInternalVouchers();
    const [showCreateInvoice, setShowCreateInvoice] = useState(false);
    const history = useNavigate();
    const isAuthorized = useAuthorize();
    const handleChangePage = (e, page) => {
        setParameterSearch({
            ...filters,
            pageNumber: Number(page)
        });
    }

    const handleFilterChange = (e) => {
        setParameterSearch({
            ...filters,
            [e.target.name]: e.target.value,
            pageNumber: 1
        });
    }

    const handleOnCreate = (order) => {
        setShowCreateInvoice(false);
        history(`/internalVouchers/create`, { state: { order } })
    }

    return (
        <>
            <Grid size="grow">
                <Paper className={classes.paper}>
                    <Typography variant="h4">
                        {title}
                    </Typography>
                </Paper>
            </Grid>
            {
                showCreateInvoice &&
                isAuthorized([Permissions.ComprobanteInter]) &&
                <InternalVoucherModal
                    open
                    onClose={() => setShowCreateInvoice(false)}
                    onCreate={handleOnCreate}
                />
            }
            <Filters
                filters={filters}
                onFilterChange={handleFilterChange}
                cashRegisters={cashRegisters}
                clearFilters={clearFilters}
            />
            <DataGrid
                columns={columns}
                rows={internalVouchers}
                loading={loading}
                paginationProps={{
                    count: totalPage,
                    page: filters?.pageNumber || 1,
                    onChange: handleChangePage
                }}
                actions={({ row }) => (
                    <>
                        <ViewButton to={`/internalVouchers/detail/${row.id}`} from={`/internalVouchers${search}`} />
                    </>
                )}
            />
            <FabContainer>
                {isAuthorized([Permissions.ComprobanteInter]) && <CreateFab onClick={() => setShowCreateInvoice(true)} />}
            </FabContainer>
        </>
    );
}

export default InternalVouchers;